module.exports = __webpack_public_path__ + "static/media/BrownColorLoader.05b01479.gif";